import React, { Component, Fragment } from "react";

import Navigation from "../Navigation";
import { Config } from "../../config";
import { inject, observer } from "mobx-react";
import { languageContent } from "../../@helpers";
import axios from "axios";
import "./style.scss";

@inject("FooterTextStore")
@observer
class SiteFooter extends Component {
  state = { footerData: {} };

  UNSAFE_componentWillMount() {
    const {
      FooterTextStore: { populate }
    } = this.props;
    populate();
  }

  componentDidMount() {
    const href = window.location.href.split("/");
    let slug = href[href.length - 1];
    slug = slug ? slug : "more-than-height";
    if (slug === "ar") slug = "more-than-height";

    const endpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.wp}${Config.endpoint.wordpress.pages}?slug=${slug}`;
    axios.get(endpoint).then(response => {
      if (response.data[0]) {
        const footerOverride = response.data[0].acf.footer_override;
        console.log(footerOverride)
        this.setState({
          footerOverride: footerOverride
        });
      }
    });
  }


  render() {
    const {
      FooterTextStore: { footerData }
    } = this.props;
    const content = languageContent();
    const { component } = content;
    const {
      Buttons: { backToTop }
    } = component.General;
    return (
      <Fragment>
        <footer className="site-footer">
          <div className="button_container">
            <a
              className="button"
              href="#content"
              onClick={() => window.scrollTo(0, 0)}
            >
              {backToTop}
            </a>
          </div>
          <div className="first_logo">
            {process.env.REACT_APP_LANG === 'en-gb' && <img src="/static/logo_mth.svg" alt="More than Height" />}
            {process.env.REACT_APP_LANG === 'es-es' && <img src="/static/logo_mth_es.png" alt="More than Height" />}
            {process.env.REACT_APP_LANG === 'ar-ar' && <img src="/ar/static/logo_mth_ar.png" alt="More than Height" />}
            {process.env.REACT_APP_LANG === 'fr-fr' && <img src="/static/logo_mth_fr.png" alt="More than Height" />}
          </div>
          <div className="last_logo">
            <a
              href={Config.site.novoNordiskLogo.link}
              title={Config.site.novoNordiskLogo.title}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              <img src="/static/logo_novo.svg" alt="Novo Nordisk" />
            </a>
          </div>
          <div className="colophon" dir="ltr">
            {footerData.site_footer_text && (
              <address>{footerData.site_footer_text}</address>
            )}
            <div>
              <Navigation name="secondary-navigation" blank="_blank" />
              {footerData.colophon_text && (
                <Fragment>
                  <span className="divider"> | </span>&copy; <time>2020</time>{" "}
                  <address>{footerData.colophon_text}</address>{" "}
                </Fragment>
              )}
              {!this.state.footerOverride && footerData.approval_code && footerData.date_of_prep && (
                <Fragment>{footerData.approval_code}</Fragment>
              )}
              {this.state.footerOverride && (
                <Fragment>{this.state.footerOverride}</Fragment>
              )}
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }
}

export default SiteFooter;
